import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  communitiesListWrapper: {
    '& > div + div': {
      marginTop: 4,
    },
    '& > div:first-of-type': {
      marginTop: 0,
    },
  },
  narrowScreen: {},
  communitiesListSearch: {},
}));
